(() => {
  const icon = '<svg aria-hidden="true" viewBox="0 0 24 24" focusable="false"><circle cx="10.8" cy="10.8" r="6.4"></circle><path d="m16 16 4.2 4.2"></path></svg>';

  function enhanceSearch() {
    const actions = document.querySelector('.jouir-actions');
    if (!actions) return;
    const mobile = window.matchMedia('(max-width: 1050px)');

    function createMobileToggle(form) {
      const toggle = document.createElement('details');
      toggle.className = 'jouir-search-toggle';
      toggle.innerHTML = `<summary aria-label="Abrir busca">${icon}</summary>`;
      form.parentNode.insertBefore(toggle, form);
      toggle.append(form);
      const submit = form.querySelector('button');
      if (submit) {
        submit.type = 'submit';
        submit.setAttribute('aria-label', 'Pesquisar');
        submit.innerHTML = icon;
      }
      toggle.addEventListener('toggle', () => {
        if (toggle.open) requestAnimationFrame(() => form.querySelector('input')?.focus());
      });
    }

    function syncSearchLayout() {
      const toggle = actions.querySelector('.jouir-search-toggle');
      if (mobile.matches && !toggle) {
        const form = actions.querySelector('.jouir-search');
        if (form) createMobileToggle(form);
      } else if (!mobile.matches && toggle) {
        const form = toggle.querySelector('.jouir-search');
        if (form) toggle.before(form);
        toggle.remove();
      }
    }

    syncSearchLayout();
    mobile.addEventListener('change', syncSearchLayout);
  }

  function enhanceProductZoom() {
    const mediaItems = [...document.querySelectorAll('[data-product-zoom-trigger]')];
    if (!mediaItems.length) return;

    const dialog = document.createElement('dialog');
    dialog.className = 'jouir-image-zoom-dialog';
    dialog.innerHTML = '<button class="jouir-image-zoom__close" type="button" aria-label="Fechar imagem ampliada">×</button><div class="jouir-image-zoom__stage"><img class="jouir-image-zoom__image" alt=""></div><p class="jouir-image-zoom__hint">Role para ampliar · arraste para mover · pinça no celular</p>';
    document.body.append(dialog);

    const stage = dialog.querySelector('.jouir-image-zoom__stage');
    const image = dialog.querySelector('.jouir-image-zoom__image');
    const close = dialog.querySelector('.jouir-image-zoom__close');
    const state = { scale: 1, x: 0, y: 0, points: new Map(), drag: null, pinch: null };
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const distance = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);

    function render() {
      image.style.transform = `translate(${state.x}px, ${state.y}px) scale(${state.scale})`;
    }
    function reset() {
      state.scale = 1;
      state.x = 0;
      state.y = 0;
      state.points.clear();
      state.drag = null;
      state.pinch = null;
      render();
    }
    function setScale(next) {
      state.scale = clamp(next, 1, 4);
      if (state.scale === 1) {
        state.x = 0;
        state.y = 0;
      }
      render();
    }
    function open(item) {
      const source = item.querySelector('img');
      if (!source) return;
      reset();
      image.src = item.dataset.zoomSrc || source.currentSrc || source.src;
      image.alt = item.dataset.zoomAlt || source.alt || 'Imagem do produto';
      dialog.showModal();
    }

    mediaItems.forEach((item) => {
      item.addEventListener('click', () => open(item));
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open(item);
        }
      });
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', reset);
    stage.addEventListener('wheel', (event) => {
      event.preventDefault();
      setScale(state.scale + (event.deltaY < 0 ? 0.2 : -0.2));
    }, { passive: false });
    stage.addEventListener('pointerdown', (event) => {
      stage.setPointerCapture(event.pointerId);
      state.points.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (state.points.size === 1) state.drag = { x: event.clientX, y: event.clientY, originX: state.x, originY: state.y };
      if (state.points.size === 2) {
        const [a, b] = [...state.points.values()];
        state.pinch = { distance: distance(a, b), scale: state.scale };
      }
      stage.classList.add('is-dragging');
    });
    stage.addEventListener('pointermove', (event) => {
      if (!state.points.has(event.pointerId)) return;
      state.points.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (state.points.size === 2 && state.pinch) {
        const [a, b] = [...state.points.values()];
        setScale(state.pinch.scale * (distance(a, b) / state.pinch.distance));
      } else if (state.drag && state.scale > 1) {
        const bound = (state.scale - 1) * Math.min(stage.clientWidth, stage.clientHeight) / 2;
        state.x = clamp(state.drag.originX + event.clientX - state.drag.x, -bound, bound);
        state.y = clamp(state.drag.originY + event.clientY - state.drag.y, -bound, bound);
        render();
      }
    });
    function endPointer(event) {
      state.points.delete(event.pointerId);
      state.drag = null;
      state.pinch = null;
      if (!state.points.size) stage.classList.remove('is-dragging');
    }
    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);
  }

  document.addEventListener('DOMContentLoaded', () => {
    enhanceSearch();
    enhanceProductZoom();
  });
})();
